import { render, staticRenderFns } from "./vue-multiselect-ext.vue?vue&type=template&id=f4ee99cc&"
import script from "./vue-multiselect-ext.vue?vue&type=script&lang=js&"
export * from "./vue-multiselect-ext.vue?vue&type=script&lang=js&"
import style0 from "./vue-multiselect-ext.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports